// GIS and Geospatial inner page — Industries tile 03.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function Gis() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.gis}
        eyebrow="Industries · GIS and Geospatial"
        headline="AI that sees change at"
        italicWord="national scale."
        lede="We build AI systems that give geospatial analysts a queue of high-confidence findings instead of a backlog of tiles to review."
      />

      <section className="bg-black py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6">

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What we build</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Change detection, semantic search, automated reconciliation.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              AI change-detection models trained on satellite and aerial imagery that surface meaningful
              changes and filter out noise. Semantic search across large geospatial datasets so analysts
              can query by meaning, not just coordinates or layer names.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              Automated cadastral reconciliation tools for government land administration. Computer vision
              classification pipelines for land use, vegetation cover and infrastructure monitoring.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work with GIS clients</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              We work with your existing imagery and data platforms.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              We connect to your existing imagery archives, whether satellite, aerial or drone-sourced.
              We build models that run on your infrastructure, in your security environment.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              Our systems produce outputs your analysts trust because we involve them in the validation
              process from the start. Analyst feedback loops are built into the system, not added as an
              afterthought.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Your analysts are reviewing more than deciding.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You have large volumes of imagery and limited analyst time. You need AI to triage and
              prioritise so your team focuses on the cases that matter.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You work in government, defence, resources or environmental monitoring and need a system
              that meets your security and data-residency requirements.
            </p>
          </Reveal>

        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
